import React, { forwardRef } from "react";
import { Form } from "react-bootstrap";
import {
    // useField,
    useFormikContext
    // ErrorMessage
} from "formik";
import { InputGroup, FormControl } from "react-bootstrap";
import DatePicker from "react-datepicker";
import DateRangeIcon from "@material-ui/icons/DateRange";

const CustomInput = forwardRef(({ value, onClick, placeholder, required, error }, ref) => {
    return (
        <InputGroup className="">
            <InputGroup.Prepend>
                <InputGroup.Text onClick={onClick} className="theme-icon">
                    <DateRangeIcon />
                </InputGroup.Text>
            </InputGroup.Prepend>
            <FormControl
                onClick={onClick}
                value={value}
                ref={ref}
                placeholder={placeholder}
                required={required}
                className={`form-control ${error ? "is-invalid" : "is-valid"}`}
            />
        </InputGroup>
    );
});

const SelectDatePicker = ({ label, selected, name, error, ...props }) => {
    const { setFieldValue } = useFormikContext();

    let handleColor = (time) => {
        return time.getHours() > 12 ? "text-dark" : "text-dark";
    };

    const handleDateChangeRaw = (e) => {
        e.preventDefault();
    };

    return (
        <Form.Group controlId={name} className={"d-flex flex-column"}>
            <Form.Label>{label}</Form.Label>
            <DatePicker
                {...props}
                selected={selected}
                onChange={(val) => setFieldValue(name, val)}
                showTimeSelect
                showTimeSelectOnly
                onChangeRaw={handleDateChangeRaw}
                timeClassName={handleColor}
                customInput={<CustomInput required error={error} />}
                // excludeTimes={[
                //   setHours(setMinutes(new Date(), 0), 17),
                //   setHours(setMinutes(new Date(), 30), 18),
                //   setHours(setMinutes(new Date(), 30), 19),
                //   setHours(setMinutes(new Date(), 30), 17),
                // ]}
                // withPortal
            />
            {error && <small className="text-danger custom-feedback">{error}</small>}
        </Form.Group>
    );
};

SelectDatePicker.defaultProps = {
    timeCaption: "Time",
    label: "",
    dateFormat: "HH:mm",
    timeIntervals: 10
};

export default SelectDatePicker;
